<template lang="pug">
  div.container
    app-modal-selecionar-modelo-notificacao(
      :tiposModelo="[formOptions.tipoModelo]",
      :idProcesso="formOptions.despacho.idProcesso"
      titulo='Modelos de Título',
      v-if="showModalTitulo",
      :showModal="showModalTitulo"
      @closeModal="fecharModalTitulo",
      @setTextoTitulo="setTextoDespacho"
    )
    .flex-despacho(v-if="!schema.removeTitle")
      p(v-if="isAmapa || isMa").label-nao-obrigatoria Informações para Registro do Imóvel:&nbsp
      p(v-else).label Informações para Registro do Imóvel:&nbsp
      el-button(type="primary", @click="openModalTitulo" v-if="showModelo") Modelo &nbsp
        .fa.fa-file
    app-editor-texto.margin-input(
      v-if="model && ((model[schema.inputName] || model[schema.inputName] === '') || (model.portaria && (model.portaria.memorialDescritivo || model.portaria.memorialDescritivo === '')))"
      :readonly="schema.readonly",
      @onTextChange="onTextChange",
      :value="getTextValue",
      :class="{'erro' : errors.length}"
      ref="editorTexto"
    )
</template>

<script>
import { abstractField } from 'vue-form-generator'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppModalSelecionarModeloNotificacao from '@/screens/analise/components/AppModalSelecionarModeloNotificacao'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { showModeloTitulo } = regrasAnalise.cadastro

export default {

  components: {
    AppEditorTexto,
    AppModalSelecionarModeloNotificacao
  },

  mixins: [ abstractField ],

  data () {
    return {
      showModalTitulo: false,
      isAmapa: process.env.ESTADO === 'ap',
      isMa: process.env.ESTADO === 'ma'
    }
  },

  computed: {
    getTextValue () {
      switch (this.schema.inputName) {
        case 'portaria.memorialDescritivo':
          return this.model?.portaria?.memorialDescritivo
        default:
          return this.model[this.schema.inputName]
      }
    },

    showModelo () {
      return showModeloTitulo
    }
  },

  methods: {
    onTextChange (val) {
      switch (this.schema.inputName) {
        case 'portaria.memorialDescritivo':
          this.model.portaria.memorialDescritivo = val
          break
        default:
          this.model[this.schema.inputName] = val
          break
      }
    },
    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    openModalTitulo () {
      this.showModalTitulo = true
    },

    fecharModalTitulo () {
      this.showModalTitulo = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.label {
  font-family: sans-serif;
  font-size: 14px;
  margin: 250px;
  font-weight: bold;
  color: $font-dark-color;
}
.label-nao-obrigatoria {
  font-family: sans-serif;
  font-size: 14px;
  margin: 250px;
  font-weight: bold;
  color: $font-dark-color;
}
.margin-input {
  margin-top: 30px;
  margin-bottom: 21px;
}
.container {
  margin-top: 20px;
  margin-bottom: 20px;
}

.label::after {
  content: "*";
  color: firebrick;
  font-size: 16px;
  font-weight: bolder;
  box-shadow: firebrick;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AppTextArea.vue